import React, { forwardRef } from 'react';
import { FormSectionTitle } from '../atoms/FormSectionTitle';
import { InputField } from '../atoms/InputField';

type LabeledInputFieldProps = {
  title: string;
  inline?: boolean;
  className?: string;
  ariaLabel?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const DisabledLabeledInputField = forwardRef<HTMLInputElement, LabeledInputFieldProps>(
  (_props, ref) => {
    const { inline, title, className, ariaLabel, disabled, ...props } = _props;
    const disabledClass = disabled ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : '';
    return (
      <div className={inline ? 'inline-block' : 'block'}>
        <FormSectionTitle text={title} htmlFor={props.id} />
        <InputField
          className={`${className} ${disabledClass}`}
          aria-label={ariaLabel}
          disabled={disabled}
          {...props}
          ref={ref}
        />
      </div>
    );
  }
);
DisabledLabeledInputField.displayName = 'DisabledLabeledInputField';
